import de from './locales/de';

const numberFormats = {
  de,
};

export default numberFormats;
